// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"64":"e7eaca8a","487":"65cd0818","787":"75999bca"}[chunkId] + ".js";
};